import React from 'react'
import PropTypes from 'prop-types'
import parseHTML from '@particles/parseHTML'
import {
	Modal as _Modal,
	useModal,
	ModalTransition
} from 'react-simple-hook-modal'
import 'react-simple-hook-modal/dist/styles.css'
import './modal.scss'

const Modal = ({ key, className, id, content_add, open, content }) => {
	const { isModalOpen, openModal, closeModal } = useModal(null)
	const handleClick = () => {
		openModal(id)
	}

	return (
		<>
			<div
				key={key ? key : 'modal'}
				className="is-clickable"
				onClick={handleClick}
				dangerouslySetInnerHTML={{ __html: open }}
			/>
			<_Modal
				isOpen={isModalOpen}
				onBackdropClick={closeModal}
				transition={ModalTransition.BOTTOM_UP}
			>
				<div id={id} className={`${className ? className : ''}`}>
					<div className="modal__close_container">
						<button
							className={`modal__close modal-close is-large`}
							onClick={closeModal}
							aria-label="close"
						></button>
					</div>
					{content && content}
					{content_add && (
						<div class="content-add column is-12">{content_add}</div>
					)}
				</div>
			</_Modal>
		</>
	)
}
Modal.propTypes = {
	content: PropTypes.string,
	content_add: PropTypes.string,
	id: PropTypes.string,
	className: PropTypes.string,
	open: PropTypes.string,
	key: PropTypes.string
}
Modal.defaultProps = {
	content: '',
	content_add: '',
	id: 'modal',
	className: '',
	open: '<a href="#" class="nav-link">Test</a>',
	key: 'modal'
}
export default Modal
